import React from 'react';
import PropTypes from 'prop-types';

const BrandDescription = ({ text }) => (
  <div className="row">
    <div className="small-12 columns">
      {text.split('\n').map((paragraph, index) => (
        <p key={btoa(index)}>{paragraph}</p>
      ))}
    </div>
  </div>
);

export default BrandDescription;

BrandDescription.propTypes = {
  text: PropTypes.string,
};

BrandDescription.defaultProps = {
  text: '',
};
